<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- 사용여부 -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <c-table
          ref="placetable"
          title="장소 목록"
          :columns="grid.columns"
          :data="grid.data"
          :usePaging="false"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-table
          ref="table"
          title="장소별 점검항목 목록"
          :columns="grid2.columns"
          :data="grid2.data"
          :merge="grid2.merge"
          :usePaging="false"
          selection="multiple"
          rowKey="saiPatrolResultItemId"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable && pick.placeId" 
                label="추가" 
                :showLoading="false" 
                icon="add" 
                @btnClicked="addItem" />
              <c-btn 
                v-if="editable && pick.placeId" 
                label="삭제" 
                icon="remove" 
                @btnClicked="deleteItem" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-place-item',
  data() {
    return {
      searchParam: {
        plantCd: '',
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소',
            align: 'left',
            sortable: true,
            style: 'width:200px',
          },
          {
            name: 'itemCnt',
            field: 'itemCnt',
            label: '점검항목 갯수',
            align: 'right',
            sortable: true,
            style: 'width:60px',
            type: 'cost',
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            sortable: true,
            style: 'width:40px',
          },
        ],
        data: [],
      },
      grid2: {
        merge: [
          { index: 0, colName: 'saiEquipClassName' },
          { index: 1, colName: 'groupItemClass' },
        ],
        columns: [
          {
            name: 'saiEquipClassName',
            field: 'saiEquipClassName',
            label: '설비분류',
            align: 'center',
            sortable: true,
            style: 'width:15%',
          },
          {
            name: 'saiItemClassName',
            field: 'saiItemClassName',
            label: '항목분류',
            align: 'center',
            sortable: true,
            style: 'width:15%',
          },
          {
            name: 'patrolItemName',
            field: 'patrolItemName',
            label: '점검항목',
            align: 'left',
            sortable: true,
            style: 'width:70%',
          },
        ],
        data: [],
      },
      editable: true,
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      popupOptions: {
        isFull: false,
        width: '50%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      pick: {
        plantCd: '',
        placeId: '',
      },
      isSave: false,
      listUrl: '',
      detailListUrl: '',
      insertUrl: '',
      deleteUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.patrol.resultItem.place.url;
      this.detailListUrl = selectConfig.sai.patrol.resultItem.list.url;
      this.insertUrl = transactionConfig.sai.patrol.itemPlace.insert.url;
      this.deleteUrl = transactionConfig.sai.patrol.itemPlace.delete.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    rowClick(row) {
      if (!row) return;
      this.pick.plantCd = row.plantCd
      this.pick.placeId = row.placeId
      this.$http.url = this.detailListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        placeId: row.placeId
      }
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, item => {
          item.placeId = this.$_.clone(this.pick.placeId)
        })
        this.grid2.data = _result.data;
      },);
    },
    addItem() {
      if (!this.pick.placeId) return;
      this.popupOptions.title = '순회점검항목';
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.pick.plantCd
      };
      this.popupOptions.target = () => import(`${'./patrolItemPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let insertData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.grid2.data, { saiPatrolResultItemId: item.saiPatrolResultItemId }) === -1) {
            // let idx = this.$_.findIndex(this.grid2.data, { saiEquipClassName: item.saiEquipClassName, saiItemClassName: item.saiItemClassName })
            // idx = idx === -1 ? this.$_.findIndex(this.grid2.data, { saiEquipClassName: item.saiEquipClassName }) : 0
            // idx = idx === -1 ? 0 : idx;
            insertData.push({
              placeId: this.pick.placeId,
              saiPatrolResultItemId: item.saiPatrolResultItemId,
              saiEquipClassName: item.saiEquipClassName,
              saiItemClassName: item.saiItemClassName,
              patrolItemName: item.patrolItemName,
            })
          }
        })
        
        this.$http.url = this.insertUrl;
        this.$http.type = 'POST';
        this.$http.param = insertData
        this.$http.request(() => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.getList();
          this.rowClick(this.$_.cloneDeep(this.pick));
        },);
      }
    },
    deleteItem() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            
            // this.$_.forEach(selectData, item => {
            //   this.grid2.data = this.$_.reject(this.grid2.data, item);
            // })
            this.$refs['table'].$refs['compo-table'].clearSelection();
            this.getList();
            /**
             * 입력하는 항목이 없음으로 삭제 처리 후에 조회처리
             */
            this.rowClick(this.$_.cloneDeep(this.pick));
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
  }
};
</script>
